import * as Sentry from '@sentry/react';

import {
  WEB_PLATFORM_ENVIRONMENT,
  WEB_PLATFORM_IS_BUILD_MODE,
  WEB_PLATFORM_VERSION,
} from 'shared/infra/constants/platform';

// Enabled is true only in production mode (build)
// not in development mode (start/local, test)
const ENABLED_LOCAL = false; // Default value should be false

Sentry.init({
  enabled: WEB_PLATFORM_IS_BUILD_MODE || ENABLED_LOCAL,
  environment: WEB_PLATFORM_ENVIRONMENT,
  release: WEB_PLATFORM_VERSION,
  dsn: process.env.REACT_APP_SENTRY_INIT_DSN,
  debug: false,
  maxBreadcrumbs: 50,
});
